module.exports = __webpack_public_path__ + "static/media/icn-check-blue-24px.8c887914.svg";